import { customRef } from "vue";

// localstorage 반응성 연결
export function useLocalStorage(key, defaultValue = "") {
  return customRef((track, trigger) => {
    return {
      get() {
        track(); 
        return localStorage.getItem(key) || defaultValue;
      },
      set(value) {
        localStorage.setItem(key, value);
        trigger();
      },
    };
  });
}